module.exports = __webpack_public_path__ + "static/timeline2004-1213484806b13f7dec611fd2679cff9a.jpeg";